import React from 'react';
import { Shield, FileText, Mail, Info } from 'lucide-react';
import type { Screen } from '../App';

interface FooterProps {
  onNavigate: (screen: Screen) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-8 sm:mt-12 md:mt-16 glass-panel rounded-xl p-6 sm:p-8">
      {/* Logo and Description */}
      <div className="text-center mb-6">
        <div className="flex items-center justify-center gap-2 mb-3">
          <Shield className="h-5 w-5 sm:h-6 sm:w-6 glass-icon" />
          <h3 className="text-base sm:text-lg font-semibold glass-text">ВОХР ТЕСТ</h3>
        </div>
        <p className="glass-text-secondary text-xs sm:text-sm max-w-2xl mx-auto leading-relaxed">
          Бесплатная образовательная платформа для подготовки сотрудников ведомственной охраны
        </p>
      </div>

      {/* Footer Links */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6">
        <button
          onClick={() => onNavigate('about')}
          className="flex flex-col items-center gap-2 p-3 glass-panel-interactive rounded-lg text-center"
          style={{ transition: 'none' }}
        >
          <Info className="h-4 w-4 sm:h-5 sm:w-5 glass-icon" />
          <span className="glass-text text-xs sm:text-sm font-medium">О проекте</span>
        </button>

        <button
          onClick={() => onNavigate('contacts')}
          className="flex flex-col items-center gap-2 p-3 glass-panel-interactive rounded-lg text-center"
          style={{ transition: 'none' }}
        >
          <Mail className="h-4 w-4 sm:h-5 sm:w-5 glass-icon" />
          <span className="glass-text text-xs sm:text-sm font-medium">Контакты</span>
        </button>

        <button
          onClick={() => onNavigate('privacy')}
          className="flex flex-col items-center gap-2 p-3 glass-panel-interactive rounded-lg text-center"
          style={{ transition: 'none' }}
        >
          <Shield className="h-4 w-4 sm:h-5 sm:w-5 glass-icon" />
          <span className="glass-text text-xs sm:text-sm font-medium">Конфиденциальность</span>
        </button>

        <button
          onClick={() => onNavigate('terms')}
          className="flex flex-col items-center gap-2 p-3 glass-panel-interactive rounded-lg text-center"
          style={{ transition: 'none' }}
        >
          <FileText className="h-4 w-4 sm:h-5 sm:w-5 glass-icon" />
          <span className="glass-text text-xs sm:text-sm font-medium">Соглашение</span>
        </button>
      </div>

      {/* Copyright */}
      <div className="text-center pt-4 border-t border-white/10">
        <p className="glass-text-secondary text-xs sm:text-sm mb-3">
          © {currentYear} ВОХР ТЕСТ. Все права защищены.
        </p>
        
        {/* Yandex Webmaster Counter */}
        <div className="flex justify-center items-center">
          <a 
            href="https://webmaster.yandex.ru/siteinfo/?site=https://vohr-test.ru"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
            style={{ borderRadius: '8px', overflow: 'hidden' }}
          >
            <img 
              width="88" 
              height="31" 
              alt="Яндекс.Вебмастер" 
              src="https://yandex.ru/cycounter?https://vohr-test.ru&theme=light&lang=ru"
              style={{ border: '0', borderRadius: '8px' }}
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

